export const SIDEBAR_MENUS = [
  {
    title: 'Auth User',
    subMenuItems: [
      {
        title: 'Activity',
        icon: 'icon-activity',
        link: 'admin/activity',
      },
      {
        title: 'Applications',
        icon: 'icon-application-icon',
        link: 'admin/apps',
      },
      {
        title: 'Users',
        icon: 'icon-user',
        link: 'admin/users',
      },
      {
        title: 'Organizations',
        icon: 'icon-organisation',
        link: 'admin/organizations',
      },
      {
        title: 'Logs',
        icon: 'icon-logs',
        link: 'admin/logs',
      },
      {
        title: 'Preferences',
        icon: 'icon-configuration',
        link: 'admin/preferences',
      },
    ],
  },
];

export const USER_MENUS = [
  {
    iconClass: 'icon-user',
    label: 'Profile',
    link: 'admin/profile',
  },
  {
    iconClass: 'icon-settings',
    label: '2 Factor Auth',
    link: 'admin/security',
  },
  {
    iconClass: 'icon-logout',
    label: 'Log out',
    link: '/logout',
  },
];
